module.exports = __webpack_public_path__ + "cook-islands.svg?5bdb5c9bbf5b068fb1ac1ce665c36c6a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/cook-islands.svg
// module id = 140
// module chunks = 10